var _effectorFileName = "/src/shared/lib/effector/router/model.ts";
import { withFactory as _withFactory } from "effector";
import type { Url } from 'next/dist/shared/lib/router/router';
import type { ReadonlyURLSearchParams } from 'next/navigation';
import Router, { NextRouter } from 'next/router';
import { attach, createEvent, createStore, sample } from 'effector';
import { reset, spread } from 'patronum';
export const setup = createEvent<{
  router: NextRouter | null;
  searchParams: ReadonlyURLSearchParams | null;
  pathname: string | null;
}>({
  loc: {
    file: _effectorFileName,
    line: 7,
    column: 21
  },
  name: "setup",
  sid: "51wd16"
});
const setRouter = createEvent<NextRouter | null>({
  loc: {
    file: _effectorFileName,
    line: 12,
    column: 18
  },
  name: "setRouter",
  sid: "cnsk5k"
});
const setSearchParams = createEvent<ReadonlyURLSearchParams | null>({
  loc: {
    file: _effectorFileName,
    line: 13,
    column: 24
  },
  name: "setSearchParams",
  sid: "-3dgxjj"
});
const setPathname = createEvent<string | null>({
  loc: {
    file: _effectorFileName,
    line: 14,
    column: 20
  },
  name: "setPathname",
  sid: "-8k1nwq"
});
export const $router = createStore<NextRouter | null>(Router, {
  loc: {
    file: _effectorFileName,
    line: 16,
    column: 23
  },
  name: "$router",
  sid: "-z0sg50"
});
export const $searchParams = createStore<ReadonlyURLSearchParams | null>(null, {
  loc: {
    file: _effectorFileName,
    line: 17,
    column: 29
  },
  name: "$searchParams",
  sid: "-rnjel2"
});
export const $pathname = createStore<string | null>(null, {
  loc: {
    file: _effectorFileName,
    line: 18,
    column: 25
  },
  name: "$pathname",
  sid: "bs904v"
});
export const sanitize = createEvent({
  loc: {
    file: _effectorFileName,
    line: 20,
    column: 24
  },
  name: "sanitize",
  sid: "7md8tq"
});
_withFactory({
  sid: "fp2op1",
  fn: () => reset({
    clock: sanitize,
    target: [$router, $searchParams, $pathname]
  }),
  name: "none",
  method: "reset",
  loc: {
    file: _effectorFileName,
    line: 22,
    column: 0
  }
});
sample({
  and: [{
    clock: setRouter,
    target: $router
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 24,
      column: 0
    },
    sid: "fq69vr"
  }
});
sample({
  and: [{
    clock: setSearchParams,
    target: $searchParams
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 29,
      column: 0
    },
    sid: "fsx8uk"
  }
});
sample({
  and: [{
    clock: setPathname,
    target: $pathname
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 34,
      column: 0
    },
    sid: "g77w9y"
  }
});
sample({
  and: [{
    clock: setup,
    target: _withFactory({
      sid: "-rtmt52",
      fn: () => spread({
        targets: {
          router: setRouter,
          searchParams: setSearchParams,
          pathname: setPathname
        }
      }),
      name: "target",
      method: "spread",
      loc: {
        file: _effectorFileName,
        line: 41,
        column: 10
      }
    })
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 39,
      column: 0
    },
    sid: "g9yv8r"
  }
});
export const navigateToFx = attach({
  and: {
    source: {
      router: $router
    },
    effect: ({
      router
    }, {
      url,
      options
    }: {
      url: Url;
      options?: {
        shallow?: boolean;
        locale?: string | false;
        scroll?: boolean;
        unstable_skipClientCache?: boolean;
      };
    }) => {
      if (!router) return;
      return router.push(url, undefined, options);
    }
  },
  or: {
    loc: {
      file: _effectorFileName,
      line: 50,
      column: 28
    },
    name: "navigateToFx",
    sid: "g37r5u"
  }
});